<template>
	<div>
		<short-header />
		<panel-nav02 />
	</div>
</template>

<script>
import ShortHeader from '~/components/layouts/headers/ShortHeader.vue';
import PanelNav02 from '~/components/panels/NAV/PanelNav02.vue';

export default {
	name: 'AboutProgrammes',
	components: {
		PanelNav02,
		ShortHeader,
	},
	provide() {
		const appData = {};
		const groupData = {};
		const taxonomyData = {};

		Object.defineProperty(appData, 'events', {
			enumerable: true,
			get: () => this.events,
		});

		Object.defineProperty(appData, 'filters', {
			enumerable: true,
			get: () => this.filters,
		});

		Object.defineProperty(groupData, 'groups', {
			enumerable: true,
			get: () => this.groups,
		});

		Object.defineProperty(groupData, 'isLoading', {
			enumerable: true,
			get: () => this.isLoading,
		});

		Object.defineProperty(taxonomyData, 'taxonomies', {
			enumerable: true,
			get: () => this.taxonomies,
		});

		Object.defineProperty(taxonomyData, 'currentTaxonomy', {
			enumerable: true,
			get: () => this.currentTaxonomy,
			set: (value) => {
				this.currentTaxonomy = value;
			},
		});

		return {
			appData,
			groupData,
			taxonomyData,
			setFilter: (filter, value) => {
				this.filters[filter] = value;
			},
		};
	},
	async asyncData({ app }) {
		const { $api } = app;

		const [taxonomies, groups, events] = await Promise.all([
			$api.getEventTaxonomies(app.i18n.locale),
			$api.getEventTaxonomiesGroups(app.i18n.locale),
			$api.getEvents(app.i18n.locale),
		]);

		return {
			taxonomies: taxonomies.data,
			groups: groups.data,
			events,
		};
	},
	data() {
		return {
			filters: {
				page: 1,
				search: '',
				taxonomyOptions: [],
			},
			taxonomies: {},
			currentTaxonomy: null,
			groups: {},
			events: {},
			isLoading: false,
		};
	},
	watch: {
		filters: {
			handler(filters) {
				this.$router.push({ query: { ...this.$route.query, ...filters } });
			},

			deep: true,
		},
		'$route.query': {
			handler(query) {
				if (query) {
					this.filters.page = query.page ?? 1;
					this.filters.taxonomyOptions = query.taxonomyOptions ?? [];
					this.filters.taxonomy = query.taxonomy ?? null;

					this.isLoading = true;

					this.$api.getEvents(this.$i18n.locale, query).then((response) => {
						this.events = response;
					});

					this.$api.getEventTaxonomiesGroups(this.$i18n.locale, query).then((response) => {
						this.groups = response.data;
					});

					this.isLoading = false;
				}
			},
			deep: true,
			immediate: true,
		},
	},
	created() {
		if (this.$route.query.search) {
			this.filters.search = this.$route.query.search;
		}
	},
};
</script>
